export const orderMessages = {
  'order.addressTitle': 'Shipping address',
  'order.back': 'Back',
  'order.cancel': 'Cancel order',
  'order.cancelFail': 'Cancel failed',
  'order.cancelSuccess': 'Order cancelled',
  'order.createdAt': 'Placed at',
  'order.detailTitle': 'Order detail',
  'order.empty': 'No orders yet',
  'order.goodsTotal': 'Subtotal',
  'order.itemsTitle': 'Items',
  'order.listTitle': 'My orders',
  'order.moreItems': '+{n} more',
  'order.notFound': 'Order not found',
  'order.orderNo': 'Order no.',
  'order.payable': 'Total',
  'order.shippingFee': 'Shipping',
  'order.status.all': 'All',
  'order.total': 'Total',
  // Payment
  'payment.title': 'Confirm Payment',
  'payment.amount': 'Amount',
  'payment.orderId': 'Order ID',
  'payment.method.balance': 'Balance',
  'payment.method.balanceDesc': 'Pay with account balance',
  'payment.method.wechat': 'WeChat Pay',
  'payment.method.wechatDesc': 'Scan QR code with WeChat',
  'payment.method.alipay': 'Alipay',
  'payment.method.alipayDesc': 'Scan QR code with Alipay',
  'payment.confirm': 'Confirm Payment',
  'payment.cancel': 'Cancel',
  'payment.processing': 'Processing',
  'payment.success': 'Payment Successful',
  'payment.successSub': 'Your order has been paid',
  'payment.failed': 'Payment Failed',
  'payment.failedSub': 'Please check your network and retry',
  'payment.retry': 'Retry Payment',
  // Refund / After-sale
  'refund.requestBtn': 'Request Refund',
  'refund.processing': 'Processing…',
  'refund.confirmTitle': 'Confirm Refund',
  'refund.confirmDesc': 'Confirm refund request? Refunds are processed within 1-3 business days',
  'refund.confirmBtn': 'Confirm',
  'refund.success': 'Refund request submitted',
  'refund.reason1': 'Item not as described',
  'refund.reason2': 'Item damaged',
  'refund.reason3': 'No longer needed',
  'refund.reason4': 'Wrong item sent',
  'admin.order.status.refunding': 'Refunding',
};
